import { render, staticRenderFns } from "./Rfis.vue?vue&type=template&id=e96cadd0&scoped=true&lang=pug&"
import script from "./Rfis.vue?vue&type=script&lang=js&"
export * from "./Rfis.vue?vue&type=script&lang=js&"
import style0 from "./Rfis.vue?vue&type=style&index=0&id=e96cadd0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e96cadd0",
  null
  
)

export default component.exports